var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.25C11.5 2.83579 11.1642 2.5 10.75 2.5C10.3358 2.5 10 2.83579 10 3.25V11.8636L7.04526 8.73503C6.76085 8.43389 6.28617 8.42033 5.98503 8.70474C5.6839 8.98915 5.67033 9.46383 5.95474 9.76497L10.2047 14.265C10.3464 14.415 10.5437 14.5 10.75 14.5C10.9563 14.5 11.1536 14.415 11.2953 14.265L15.5453 9.76497C15.8297 9.46383 15.8161 8.98915 15.515 8.70474C15.2138 8.42033 14.7392 8.43389 14.4547 8.73503L11.5 11.8636V3.25Z",
    fill: "#1A2448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 13.25C4.25 12.8358 3.91421 12.5 3.5 12.5C3.08579 12.5 2.75 12.8358 2.75 13.25V15.75C2.75 17.2688 3.98122 18.5 5.5 18.5H16C17.5188 18.5 18.75 17.2688 18.75 15.75V13.25C18.75 12.8358 18.4142 12.5 18 12.5C17.5858 12.5 17.25 12.8358 17.25 13.25V15.75C17.25 16.4404 16.6904 17 16 17H5.5C4.80964 17 4.25 16.4404 4.25 15.75V13.25Z",
    fill: "#1A2448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSmall);
export default __webpack_public_path__ + "static/media/download-small.ce8ecf8637405239a6fb519bb37b519e.svg";
export { ForwardRef as ReactComponent };